/*
 * stock-waitlist.js
 * -------------------------------------------------------------------------
 * "Join Waitlist" (back-in-stock) capture for out-of-stock products.
 *  - Logged-in shoppers are enrolled instantly with their account email.
 *  - Guests get a small inline email prompt.
 * Enrolments POST to the ZNOS Marketing Intelligence module, which emails
 * everyone automatically when the product returns to stock.
 *
 * Config comes from window.ZNOS_WAITLIST (set in layout/theme.liquid):
 *   { apiBase, shop, email, customerId }
 * -------------------------------------------------------------------------
 */
(function () {
  var CFG = window.ZNOS_WAITLIST || {};
  if (!CFG.apiBase || !CFG.shop) return;

  function post(payload) {
    return fetch(CFG.apiBase.replace(/\/$/, '') + '/api/v1/marketing/stock-waitlist/enroll', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
  }

  function payloadFor(btn, email) {
    var path = btn.getAttribute('data-product-url') || '';
    var url = path && path.indexOf('http') !== 0 ? location.origin + path : path;
    return {
      shop: CFG.shop,
      productId: btn.getAttribute('data-product-id'),
      variantId: btn.getAttribute('data-variant-id') || '',
      email: email,
      productHandle: btn.getAttribute('data-product-handle') || undefined,
      productTitle: btn.getAttribute('data-product-title') || undefined,
      productUrl: url || undefined,
      imageUrl: btn.getAttribute('data-image-url') || undefined,
      variantTitle: btn.getAttribute('data-variant-title') || undefined,
      customerId: CFG.customerId || undefined,
    };
  }

  function markDone(btn) {
    btn.classList.add('wl-join--done');
    btn.disabled = true;
    var label = btn.querySelector('.wl-join__label');
    if (label) label.textContent = "You're on the list";
  }

  function enroll(btn, email) {
    btn.classList.add('wl-join--loading');
    post(payloadFor(btn, email))
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () { markDone(btn); closeModal(); })
      .catch(function () {
        btn.classList.remove('wl-join--loading');
        showModalError('Something went wrong. Please try again.');
      });
  }

  // ── Guest email modal (built once, reused) ──────────────────────────────
  var modal;
  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'wl-modal';
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="wl-modal__backdrop" data-wl-close></div>' +
      '<div class="wl-modal__card" role="dialog" aria-modal="true" aria-labelledby="wl-modal-title">' +
      '<button class="wl-modal__x" data-wl-close aria-label="Close">&times;</button>' +
      '<h3 class="wl-modal__title" id="wl-modal-title">Get notified when it’s back</h3>' +
      '<p class="wl-modal__sub">Enter your email and we’ll let you know the moment this item is back in stock.</p>' +
      '<form class="wl-modal__form"><input type="email" required placeholder="you@email.com" class="wl-modal__input" autocomplete="email" />' +
      '<button type="submit" class="wl-modal__submit">Notify me</button></form>' +
      '<div class="wl-modal__err" hidden></div>' +
      '<div class="wl-modal__ok" hidden>✓ You’re on the list! We’ll email you.</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-wl-close')) closeModal();
    });
    modal.querySelector('.wl-modal__form').addEventListener('submit', function (e) {
      e.preventDefault();
      var email = modal.querySelector('.wl-modal__input').value.trim();
      if (!email) return;
      if (modal._btn) enroll(modal._btn, email);
    });
  }
  function openModal(btn) {
    if (!modal) buildModal();
    modal._btn = btn;
    modal.querySelector('.wl-modal__err').hidden = true;
    modal.querySelector('.wl-modal__ok').hidden = true;
    modal.querySelector('.wl-modal__form').hidden = false;
    modal.removeAttribute('hidden');
    setTimeout(function () { modal.querySelector('.wl-modal__input').focus(); }, 30);
  }
  function closeModal() { if (modal) modal.setAttribute('hidden', ''); }
  function showModalError(msg) {
    if (!modal) return;
    var e = modal.querySelector('.wl-modal__err');
    e.textContent = msg; e.hidden = false;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wl-join]') : null;
    if (!btn || btn.classList.contains('wl-join--done') || btn.classList.contains('wl-join--loading')) return;
    e.preventDefault();
    e.stopPropagation();
    if (CFG.email) enroll(btn, CFG.email); // logged in — use account email
    else openModal(btn);
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
})();
